<template>
  <div class="qr-wrapper" :style="containerStyle">
    <div :id="regionId"  :style="containerStyle" class="qr-region"></div>
    <div v-if="loadingStart" class="qr-overlay">
      <div class="spinner"></div>
      <div class="spinner-label">Uruchamianie kamery…</div>
    </div>
  </div>
</template>

<script>
import { Html5Qrcode } from 'html5-qrcode'

export default {
  name: 'QrScanner',
  props: {
    headerOffset: {
      type: Number,
      default: 64,
    },
  },
  data() {
    return {
      html5Qr: null,
      regionId: 'qr-reader-' + Math.random().toString(36).slice(2),
      scanning: false,
	  paused: false,
	  loadingStart: false,
	  viewportHeight: typeof window !== 'undefined' ? window.innerHeight : 0,
    }
  },
  computed: {
    containerStyle() {
      const h = Math.max(0, this.viewportHeight - this.headerOffset)
      return { width: '100%', height: `${h}px`, position: 'relative', overflow: 'hidden', background: '#000' }
    },
  },
  mounted() {
    this.html5Qr = new Html5Qrcode(this.regionId, { verbose: true })
    window.addEventListener('resize', this.onResize)
    window.addEventListener('orientationchange', this.onResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
    window.removeEventListener('orientationchange', this.onResize)
    this.stop()
  },
  methods: {
    async start() {
		this.loadingStart = true
		this.$emit('scanner-starting')
      try {
        if (!window.isSecureContext) {
			console.error('[QR] insecure context: require HTTPS or localhost')
	        this.$emit('error', new Error('Skaner wymaga HTTPS lub localhost.'))
			this.$emit('scanner-error', new Error('insecure'))
			this.loadingStart = false
			return
        }
        const cams = await Html5Qrcode.getCameras()
        console.log('[QR] cameras', cams)
        if (!cams || cams.length === 0) {
          const err = new Error('Brak kamery. Uruchom na urządzeniu mobilnym lub użyj uploadu zdjęcia.')
          this.$emit('error', err)
          this.$emit('scanner-error', err)
          this.loadingStart = false
          return
        }
        await this.html5Qr.start(
          { facingMode: 'environment' },
			{
				fps: 10,
				qrbox: (vw, vh) => {
				const size = Math.floor(Math.min(vw, vh) * 0.9) // prawie cały ekran
				return { width: size, height: size }
				},
				aspectRatio: window.innerWidth / (window.innerHeight - this.headerOffset),
			},
          (text) => {
            this.$emit('decoded', text)
			this.pause()
            // this.stop()
          },
          (err) => {
            /* ignore scan errors */
          },
        )
        this.scanning = true
		this.paused = false
		this.loadingStart = false
		this.$emit('scanner-started')
      } catch (e) {
        console.error('[QR] start error', e)
        this.$emit('error', e)
		this.$emit('scanner-error', e)
        this.scanning = false
		this.loadingStart = false
      }
    },
    async stop() {
      if (this.html5Qr && this.scanning) {
        await this.html5Qr.stop()
        await this.html5Qr.clear()
        this.scanning = false
		this.paused = false
		this.loadingStart = false
      }
    },
	pause() {
      if (this.html5Qr && this.scanning && !this.paused) {
        try { this.html5Qr.pause(true) } catch (e) {}
        this.paused = true
      }
    },
    resume() {
      if (this.html5Qr && this.scanning && this.paused) {
        try { this.html5Qr.resume() } catch (e) {}
        this.paused = false
      }
    },
	onResize() {
		this.viewportHeight = window.innerHeight || this.viewportHeight
		if (this.scanning) {
			this.stop().then(() => this.start())
		}
    },
  },
}
</script>

<style scoped>
.qr-wrapper { position: relative; }
.qr-region { position: absolute; top: 0; left: 0; right: 0; bottom: 0; }
.qr-overlay { position: absolute; inset: 0; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 12px; color: #fff; background: rgba(0,0,0,0.2); z-index: 2; }
.spinner { width: 48px; height: 48px; border: 4px solid rgba(255,255,255,0.25); border-top-color: var(--color-red-orange); border-radius: 50%; animation: spin 1s linear infinite; }
.spinner-label { font-weight: 600; }
@keyframes spin { to { transform: rotate(360deg); } }
.qr-region >>> video {
  width: 100% !important;
  height: 100% !important;
  object-fit: cover !important;
}
</style>
